import { MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { DateTime } from 'luxon';
import { Inject, Injectable, Optional } from '@angular/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { AppConstant } from '@app/app.constant';

@Injectable()
export class AppLuxonDateAdapter extends LuxonDateAdapter {

    constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
        super(dateLocale);
    }

    override format(date: DateTime, displayFormat: string): string {
        if (!this.isValid(date)) {
            throw Error('AppLuxonDateAdapter: Cannot format invalid date.');
        }
        if (displayFormat === 'input') {
            return date.toFormat(AppConstant.FORMAT_DATE_LUXON);
        } else {
            return date.toFormat(displayFormat);
        }
    }

    override deserialize(value: any): DateTime | null {
        if (typeof value === 'string') {
            const fromCustom = DateTime.fromFormat(value, AppConstant.FORMAT_DATE_LUXON);
            if (fromCustom.isValid) return fromCustom;

            const fromTimeDate = DateTime.fromFormat(value, AppConstant.FORMAT_TIME_DATE_LUXON);
            if (fromTimeDate.isValid) return fromTimeDate;

            const fromISO = DateTime.fromISO(value);
            if (fromISO.isValid) return fromISO;

            const fromSQL = DateTime.fromSQL(value);
            if (fromSQL.isValid) return fromSQL;
        }
        return super.deserialize(value);
    }
}

export const APP_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: 'dd/MM/yyyy'
    },
    display: {
        dateInput: 'input',
        dateA11yLabel: 'dd LLLL yyyy',
        monthYearA11yLabel: 'LLLL yyyy',
        monthYearLabel: 'LLL yyyy'
    }
};
